export function isLiked(keys: string[]): boolean {
  if (process.env.BROWSER) {
    const key = (['like'].concat(keys)).join('/');
    const v = localStorage.getItem(key);
    if (key && JSON.parse(v)) {
      return true;
    }
  }
  return false;
}

export function setLiked(keys: string[], value: boolean): void {
  if (process.env.BROWSER) {
    const key = (['like'].concat(keys)).join('/');
    const v = localStorage.setItem(key, JSON.stringify(value));
  }
}
